<template>

  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="">
          <el-select v-model="formInline.status" placeholder="政商企状态">
            <el-option label="全部" value="-1"></el-option>
            <el-option v-for="(item,index) in status" :key="index" :label="item" :value="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label=""><el-input v-model="formInline.name" placeholder="政商企名称"></el-input></el-form-item>
        <el-form-item><el-button icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
      </el-form>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small"  :data="tableData" border style="width: 100%" v-loading="loading">
             <el-table-column prop="supply_id" label="政商企ID"></el-table-column>
            <el-table-column prop="name" label="政商企名称"></el-table-column>
            <el-table-column prop="number" label="可创建名片数量">
              <template slot-scope="scope">
                <div>
                  <el-input type="number" size="small" @change="updateCardNum(scope.row,scope.row.supply_id)" placeholder="请输入可创建名片数量" v-model="scope.row.cardauth.number">
                  </el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="number" label="状态">
              <template slot-scope="scope">
                <div v-if="scope.row.status==1">
                  启用  
                </div>
                <div v-else>
                  禁用
                </div>   
              </template>
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import CardApi from '@/api/card.js';
export default {
  components: {},
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      formInline: {},
      status: ['禁用', '启用']
    };
  },
  created() {

    /*获取列表*/
    this.getTableList();
  },
  methods: {

    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      CardApi.supplyList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },
    //更改可创建名片数量
    updateCardNum(item,supply_id){
      let self = this;
      let Params = {};
      Params.supply_id = supply_id;
      Params.number = item.cardauth.number;
      self.loading = true;
      CardApi.editCardAuth(Params, true)
        .then(data => {
          self.loading = false;
          self.getTableList();
          if(data.code==1){
             self.$message({
              message: data.msg,
              type: 'success'
            });
          }else{
             self.$message({
              message: data.msg,
              type: 'error'
            });
          }
         
        })
        .catch(error => {});
    }


  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/card/cardauth/part/Basic.vue